function isPrerender() {
  const { userAgent } = window.navigator;

  return userAgent.indexOf('Prerender') !== -1;
}

export { isPrerender };
